<template>
  <div
    class="tw-bg-white tw-rounded-2xl tw-flex tw-flex-col tw-relative tw-overflow-hidden"
  >
    <div
      v-if="isCreamBannerVisible"
      class="tw-bg-[#FF9D42] tw-p-2 tw-absolute tw-z-20 tw-top-0 tw-left-0 tw-right-0 tw-block lg:tw-hidden"
    >
      <p class="tw-mb-0 tw-text-center tw-text-sm md:tw-text-base">
        Get the Estriol Cream with Tretinoin for a discounted price of <span class="tw-font-bold">$99 RIGHT NOW ONLY!</span>
      </p>
    </div>
    <div
      class="tw-w-full tw-relative tw-flex tw-p-4"
      :class="{ 'tw-pt-16 sm:tw-pt-12 md:tw-pt-12 lg:tw-pt-0': isCreamBannerVisible }"
    >
      <div class="tw-relative tw-w-full">
        <img
          :src="productData.images[0]"
          class="tw-h-[300px] tw-w-full tw-object-cover tw-rounded-2xl"
          :class="{'tw-object-[0_-73px] md:tw-object-[0_-131px] lg:tw-object-[0_-128px]': ['G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant) && productData.upsellcode === 'CREAM'}"
        >
        <div
          class="tw-bg-[#1a6a72] tw-inline-flex tw-justify-center tw-items-center tw-absolute tw-top-[10px] lg:tw-top-4 tw-right-[10px] tw-text-white tw-text-center tw-z-10 lg:tw-z-auto tw-gap-1 tw-px-2 tw-py-1 tw-rounded-full"
        >
          <template v-if="['F3v1', 'F2','E1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">
            <template v-if="productData.upsellcode === 'CREAM'">
              <template v-if="['E1', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">
                <img
                  class="tw-p-1"
                  alt="stethoscope"
                  src="@/assets/images/upsell/stethoscope.svg"
                >
                <span class="tw-text-base tw-text-white tw-font-atten-medium">
                  Recommended for {{ onboardingPatient.firstname }}
                </span>
              </template>
              <template v-else>
                <img
                  alt="star"
                  src="@/assets/images/upsell/star.svg"
                >
                <span class="tw-text-base tw-text-white tw-font-atten-medium">
                  Highly-rated
                </span>
              </template>
            </template>
            <template v-if="productData.upsellcode === 'BLOSSOM'">
              <img
                alt="star"
                src="@/assets/images/upsell/heart.svg"
              >
              <span class="tw-text-base tw-text-white tw-font-atten-medium">
                Customer favorite
              </span>
            </template>
            <template v-if="productData.upsellcode === 'MINOXIDIL'">
              <img
                alt="star"
                src="@/assets/images/upsell/hair.svg"
              >
              <span class="tw-text-sm tw-text-white tw-font-atten-medium">
                Recommended for <span class="tw-capitalize">{{ onboardingPatient.firstname }}</span>
              </span>
            </template>
            <template v-if="productData.upsellcode === 'DEEPSLEEP'">
              <img
                alt="hand-heart"
                src="@/assets/images/upsell/hand-heart.svg"
              >
              <span class="tw-text-base tw-text-white tw-font-atten-medium">
                Customer favorite
              </span>
            </template>
          </template>
          <template v-else>
            <img
              alt="stethoscope"
              src="@/assets/images/upsell/stethoscope.svg"
            >
            <span
              v-if="onboardingPatient.firstname"
              class="tw-text-sm"
            >
              Recommended for {{ onboardingPatient.firstname }}
            </span>
          </template>
        </div>
      </div>
    </div>
    <div class="tw-px-6 tw-pb-3 tw-w-full tw-relative tw-overflow-hidden">
      <div
        v-if="isCreamBannerVisible"
        class="tw-bg-[#FF9D42] tw-p-2 tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-hidden lg:tw-block"
      >
        <p class="tw-mb-0 tw-text-center">
          Get the Estriol Cream with Tretinoin for a discounted price of <span class="tw-font-bold">$99 RIGHT NOW ONLY!</span>
        </p>
      </div>
      <p
        v-if="['F3v1', 'F3v2'].includes(onboardingVariant)"
        class="tw-text-[1.75rem] lg:tw-text-4xl tw-mb-2 tw-tracking-tighter"
        :class="{'lg:tw-mt-5': isCreamBannerVisible}"
      >
        {{ productData.name }}
      </p>
      <p
        v-else
        class="tw-text-[1.75rem] lg:tw-text-4xl tw-mb-2 tw-tracking-tighter"
        :class="{'lg:tw-mt-5': isCreamBannerVisible}"
      >
        {{ productData.name }}
      </p>
      <p
        v-if="productData.upsellcode === 'BLOSSOM' && !['F3v1', 'F3v2'].includes(onboardingVariant)"
        class="tw-text-[#787878] tw-text-xl"
      >
        Sildenafil Arousal Cream
      </p>
      <template v-if="[ 'F3v2'].includes(onboardingVariant)">
        <p
          class="tw-inline tw-mb-2 tw-text-2xl"
        >
          <span class="tw-font-bold">{{ upsellPrice }}</span>

          <span class="tw-line-through tw-mx-[5px]">
            {{ productData.metadata.strikethroughprice }}
          </span>

          <span>
            {{ productData.metadata.upsellpriceunit }}
          </span>
        </p>
      </template>
      <template v-else>
        <p
          v-if="productData.metadata.bfcm === 'true' && !isCreamBannerVisible"
          class="tw-flex tw-text-xl tw-mb-2"
        >
          {{ upsellPrice }} - limited time only
        </p>
        <p
          v-else
          class="tw-inline tw-text-xl tw-mb-2"
        >
          New Patient Offer:
          <span class="tw-font-bold">{{ upsellPrice }}</span>
          <span v-if="productData.upsellcode === 'MINOXIDIL'">
            per 3-month supply
          </span>
          <span v-else-if="productData.upsellcode === 'DEEPSLEEP'">
            per month supply
          </span>
          <span v-else>
            {{ productData.metadata.upsellpriceunit }}
          </span>
        </p>

        <div>
          Regular price:
          <span class="tw-font-bold tw-line-through">{{ productData.metadata.strikethroughprice }}</span>
          <span
            v-if="productData.upsellcode === 'CREAM'"
            class="tw-text-[#1A6A72]"
          >
            (Save ${{ getSaving(upsellPrice, productData.metadata.strikethroughprice) }})
          </span>
          <span
            v-if="productData.upsellcode === 'BLOSSOM'"
            class="tw-text-[#1A6A72]"
          >
            (Save ${{ getSaving(upsellPrice, productData.metadata.strikethroughprice) }})
          </span>
          <span
            v-if="productData.upsellcode === 'MINOXIDIL'"
            class="tw-text-[#1A6A72]"
          >
            (Save ${{ getSaving(upsellPrice, productData.metadata.strikethroughprice) }})
          </span>
          <span
            v-if="productData.upsellcode === 'DEEPSLEEP'"
            class="tw-text-[#1A6A72]"
          >
            (Save ${{ getSaving(upsellPrice, productData.metadata.strikethroughprice) }})
          </span>
        </div>
        <p
          v-if="productData.upsellcode === 'CREAM'"
        >
          <template v-if="productData.metadata.bfcm === 'true' && !isCreamBannerVisible">
            Auto-refilled at normal price of {{ productData.metadata.strikethroughprice }}
          </template>
          <template v-else-if="productData.firstorder && !productData.isExternalLink">
            Auto-refilled, subsequent orders at full price
          </template>
          <template v-else>
            Auto-refilled
          </template>
        </p>
        <p
          v-else-if="productData.upsellcode === 'MINOXIDIL'"
        >
          Auto-refilled, subsequent orders at full price
        </p>
        <p
          v-else-if="productData.upsellcode === 'DEEPSLEEP'"
        >
          Auto-refilled, subsequent orders at full price
        </p>
        <p
          v-else
        >
          Subsequent orders at full price of {{ productData.metadata.strikethroughprice }}.
        </p>
      </template>
      <div class="tw-mt-4 tw-mb-6 lg:tw-mb-0">
        <div class="tw-grid tw-grid-cols-1 tw-gap-1 tw-mb-6">
          <div
            v-for="(benefit, index) in benefitsList"
            :key="`benefit-${index}`"
            class="tw-gap-2 tw-text-base tw-flex tw-items-center"
          >
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.41016 16.4414C12.8262 16.4414 16.4824 12.7773 16.4824 8.36914C16.4824 3.95314 12.8183 0.296875 8.40225 0.296875C3.99416 0.296875 0.337891 3.95314 0.337891 8.36914C0.337891 12.7773 4.00207 16.4414 8.41016 16.4414ZM8.41016 15.0961C4.67477 15.0961 1.69119 12.1046 1.69119 8.36914C1.69119 4.63375 4.66685 1.64226 8.40225 1.64226C12.1377 1.64226 15.1371 4.63375 15.1371 8.36914C15.1371 12.1046 12.1456 15.0961 8.41016 15.0961Z"
                fill="#1A6A72"
              />
              <path
                d="M7.57872 11.9511C7.83987 11.9511 8.06145 11.8245 8.21975 11.5792L11.8365 5.88901C11.9235 5.73073 12.0264 5.55662 12.0264 5.38251C12.0264 5.02638 11.7098 4.79688 11.3774 4.79688C11.1796 4.79688 10.9817 4.9235 10.8314 5.153L7.54705 10.4237L5.98798 8.40564C5.79805 8.15239 5.62394 8.08911 5.40235 8.08911C5.06205 8.08911 4.79297 8.36607 4.79297 8.71433C4.79297 8.88843 4.8642 9.05463 4.97499 9.20496L6.90601 11.5792C7.10386 11.8404 7.31751 11.9511 7.57872 11.9511Z"
                fill="#1A6A72"
              />
            </svg>

            <p class="tw-mb-0 tw-text-lg">
              {{ benefit }}
            </p>
          </div>
        </div>
      </div>
      <template v-if="['F3v1', 'F3v2'].includes(onboardingVariant)">
        <div
          v-if="productData.upsellcode === 'CREAM'"
          class="tw-mt-4 tw-mb-2 lg:tw-mb-0"
        >
          <img
            v-if="['F3v1', 'F3v2'].includes(onboardingVariant)"
            alt="trust pilot"
            src="@/assets/images/onboarding/trustpilot-horizontal.png"
            class="tw-mb-4"
            style="height: 30px; display: block"
          >
          <img
            v-else
            alt="trust pilot"
            src="@/assets/images/onboarding/trustpilot-horizontal-upsell.png"
            class="tw-mb-4"
            style="height: 30px; display: block"
          >
          <div class="tw-flex tw-flex-col lg:tw-flex-row">
            <p class="tw-tracking-tight tw-mb-0 tw-text-lg tw-leading-snug">
              "I've noticed a huge improvement in the fine lines on my forehead,
              I've been using it for around 6 weeks now."
            </p>
            <div class="tw-flex tw-mt-8 lg:tw-mt-0">
              <img
                class="tw-rounded-lg tw-w-auto lg:tw-w-[184px] tw-h-[150px] lg:tw-h-auto"
                alt="before-image"
                src="@/assets/images/upsell/beforeandafter1.png"
              >
            </div>
          </div>
        </div>
        <div
          v-if="productData.upsellcode === 'BLOSSOM'"
          class="tw-mt-4 tw-mb-3 lg:tw-mb-0"
        >
          <img
            v-if="['F3v1', 'F3v2'].includes(onboardingVariant)"
            alt="trust pilot"
            src="@/assets/images/onboarding/trustpilot-horizontal.png"
            class="tw-mb-4"
            style="height: 30px; display: block"
          >
          <img
            v-else
            alt="trust pilot"
            src="@/assets/images/onboarding/trustpilot-horizontal-upsell.png"
            class="tw-mb-4"
            style="height: 30px; display: block"
          >
          <div class="tw-flex tw-flex-col lg:tw-flex-row">
            <p class="tw-tracking-tight tw-mb-0 tw-text-lg tw-leading-snug">
              "Just wow. A little goes a long way, and it made everything feel
              more alive, more exciting, more me."
            </p>
          </div>
        </div>
        <div
          v-if="!['CREAM', 'BLOSSOM'].includes(productData.upsellcode)"
          class="tw-mt-4 tw-mb-3 lg:tw-mb-0"
        >
          <img
            v-if="['F3v1', 'F3v2'].includes(onboardingVariant)"
            alt="trust pilot"
            src="@/assets/images/onboarding/trustpilot-horizontal.png"
            class="tw-mb-4"
            style="height: 30px; display: block"
          >
          <img
            v-else
            alt="trust pilot"
            src="@/assets/images/onboarding/trustpilot-horizontal-upsell.png"
            class="tw-mb-4"
            style="height: 30px; display: block"
          >
          <div class="tw-flex tw-flex-col lg:tw-flex-row">
            <p class="tw-tracking-tight tw-mb-0 tw-text-lg tw-leading-snug">
              "I had tons of hair loss, 3 months on the minoxidil serum and
              my hair feels noticeably fuller and stronger now."
            </p>
            <div class="tw-flex tw-mt-8 lg:tw-mt-0">
              <img
                class="tw-rounded-lg tw-w-auto lg:tw-w-[184px] tw-h-[150px] lg:tw-h-auto"
                alt="before-image"
                src="@/assets/images/upsell/beforeandafter2.png"
              >
            </div>
          </div>
        </div>
      </template>
      <div
        v-else
        class="tw-mt-4 tw-mb-2 lg:tw-mb-0"
      >
        <CarouselSlider
          v-if="trustpilotReviews.length"
          ref="upsellReviewCarousel"
          animation="opacity"
          has-arrows
          :has-dots="false"
        >
          <CarouselItem
            v-for="({starNumber, review}, index) in trustpilotReviews"
            :key="index"
          >
            <img
              v-if="starNumber === 4"
              alt="trustpilot"
              src="@/assets/images/onboarding/trustpilot-horizontal-upsell.png"
              class="tw-mb-4"
              style="height: 30px; display: block"
            >
            <img
              v-if="starNumber === 5"
              alt="trustpilot"
              src="@/assets/images/onboarding/trustpilot-horizontal.png"
              class="tw-mb-4"
              style="width: 282.15px; display: block"
            >
            <div class="tw-flex tw-flex-col lg:tw-flex-row">
              <p class="tw-tracking-tight tw-mb-0 tw-text-lg tw-leading-snug">
                {{ review }}
              </p>
            </div>
          </CarouselItem>
        </carouselslider>
      </div>
      <template v-if="['F3v2'].includes(onboardingVariant)">
        <h3 class="tw-my-5 tw-text-[32px] md:tw-text-[40px]">
          {{ productData.faq_header }}
        </h3>
        <div v-if="productData.faq?.length">
          <UpsellCollapse
            v-for="{title, description} in productData.faq"
            :id="`collapse-${title}`"
            :key="`${title}-${uniqueId}`"
            :title="title"
          >
            <template v-if="description.list?.length">
              <ul class="tw-text-lg tw-list-disc tw-pl-[1.5rem]">
                <li
                  v-for="(item, index) in description.list"
                  :key="index"
                >
                  {{ item }}
                </li>
              </ul>
            </template>
            <p
              v-else
              class="tw-text-lg tw-m-0 tw-text-justify"
            >
              {{ description.text }}
            </p>
          </UpsellCollapse>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { v4 as uuidv4 } from 'uuid';
import creamFallbackImage from '@/assets/images/onboarding/rejection/cream.png';

// components
import CarouselSlider from '@corefront/components-v2/Carousel/CarouselSlider.vue';
import CarouselItem from '@corefront/components-v2/Carousel/CarouselItem.vue';
import UpsellCollapse from '@/components/onboarding/checkout/UpsellCollapse.vue';

export default {
  name: 'SelectProductUpsell',
  components: {
    UpsellCollapse,
    CarouselSlider,
    CarouselItem,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    upsellFrom: {
      type: String,
      default: 'Onboarding Upsell',
    },
    current: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      productData: null,
      uniqueId: uuidv4(),
    };
  },
  computed: {
    ...mapState('onboarding', ['onboardingPatient']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
    benefitsList() {
      return this.productData.metadata.new_benefits
        .split(',')
        .map(benefit => {
          return benefit.trim();
        });
    },
    isCreamBannerVisible() {
      return false
      // return this.productData.upsellcode === 'CREAM' && this.upsellFrom === 'Onboarding Upsell';
    },
    trustpilotReviews() {
      if (this.productData.upsellcode === 'CREAM') {
        return [
          { starNumber: 4, review: '"I’ve noticed a huge improvement in the fine lines on my forehead, I’ve been using it for around 6 weeks now."' },
          { starNumber: 4, review: '"I use it almost every night. My skin is smoother and much more even."' },
          { starNumber: 4, review: '"I noticed a difference in just a couple weeks. My skin is glowing!"' },
        ];
      }
      if (this.productData.upsellcode === 'BLOSSOM') {
        return [
          { starNumber: 4, review: '"Just wow. A little goes a long way, and it made everything feel more alive, more exciting, more me."' },
          { starNumber: 4, review: '"It’s like turning the volume up on sensation—I’ll never go without it again."' },
          { starNumber: 4, review: '"I love that I can use this with my husband, or by myself"!' },
        ];
      }
      if (this.productData.upsellcode === 'MINOXIDIL') {
        return [
          { starNumber: 5, review: 'I had tons of hair loss, 3 months on the minoxidil serum and my hair feels noticeably fuller and stronger now.' },
          { starNumber: 4, review: 'I was having so much anxiety about my thinning hair, I’m so happy I found a solution that works.' },
          { starNumber: 4, review: 'I’m so glad that I found minoxidil! I was taking OTC vitamins and doing all kinds of oils before, nothing worked.' },
        ];
      }
      if (this.productData.upsellcode === 'DEEPSLEEP') {
        return [
          { starNumber: 5, review: 'I’ve been sleeping so much better since starting Deep Sleep. I wake up actually feeling rested for the first time in years.' },
          { starNumber: 5, review: 'This has been a game changer. Falling asleep faster and staying asleep through the night.' },
          { starNumber: 4, review: 'I was skeptical at first but after two weeks I noticed a real difference in my sleep quality.' },
        ];
      }
      return [];
    },
    upsellPrice() {
      if (this.upsellFrom === 'Onboarding Upsell' && ['CREAM', 'MINOXIDIL', 'DEEPSLEEP'].includes(this.productData.upsellcode)) {
        return this.productData.metadata.onboarding_upsellprice
      }

      if (this.productData.isExternalLink) {
        return this.productData.metadata.upsellprice;
      }

      if (this.productData.firstorder) {
        return this.productData.metadata.firsttime_upsellprice || this.productData.metadata.upsellprice;
      }

      return this.productData.metadata.upsellprice;
    },
  },
  watch: {
    user: {
      handler(val) {
        console.log(val)
      },
      immediate: true
    },
    current: {
      handler() {
        this.uniqueId = uuidv4();
      },
      immediate: true,
    }
  },
  async created() {
    this.$set(this, 'productData', { ...this.product, selected: false });
  },
  methods: {
    getSaving(regular, promo) {
      try {
        const regularPrice = parseFloat(regular.replace('$', '').trim());
        const promoPrice = parseFloat(promo.replace('$', '').trim());

        if (isNaN(regularPrice) || isNaN(promoPrice)) {
          return 0;
        }

        return promoPrice - regularPrice;
      } catch (error) {
        return 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .upsell-card__checkbox.checkbox-container {
  padding: 0.75rem;
}

::v-deep .upsell-card__checkbox .checkbox-box {
  border-radius: 0.4rem;
}

.upsell-card__info--expanded {
  height: auto !important;
}

.upsell-card__info.upsell-card__info--expanded::after {
  display: none !important;
}

@media (max-width: 1023px) {
  .upsell-card__info::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100px; /* Height of the fade effect */
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
  }
}
</style>
